import { render, staticRenderFns } from "./automaticReplies.vue?vue&type=template&id=8bed2b52&"
import script from "./automaticReplies.vue?vue&type=script&lang=js&"
export * from "./automaticReplies.vue?vue&type=script&lang=js&"
import style0 from "./automaticReplies.vue?vue&type=style&index=0&id=8bed2b52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports